import { type Signal, computed } from "@angular/core";
import type { WkDataTableRowCalcFields } from "@components/data-table/data-table.types";

export abstract class WkDataTableRow<TItem, TCalcFields extends WkDataTableRowCalcFields = WkDataTableRowCalcFields> {
    protected abstract calculateFields: Signal<(item: TItem) => TCalcFields>;

    protected calcFieldsCached: TCalcFields | null = null;

    public calcFields = computed(() => {
        const calculateFields = this.calculateFields();
        return (item: TItem | null) => {
            if (item) this.calcFieldsCached = calculateFields(item);
            return this.calcFieldsCached;
        };
    });
}
